
import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle, DialogTrigger, Table, TableBody, TableCell, TableHeader, TableHeaderCell, TableRow, makeStyles } from "@fluentui/react-components";

import {
    AddCircle24Filled, AddCircle24Regular,
    ArrowDownload24Filled, ArrowDownload24Regular,
    bundleIcon,
} from "@fluentui/react-icons";
import { Job, JobResultParser, JobStatus } from "../../library/CosmeWidgetAPIClient";
import { useContext, useEffect, useState } from "react";
import { CWClientContext } from "../../App";
const ArrowDownload = bundleIcon(ArrowDownload24Filled, ArrowDownload24Regular);
const AddCircle = bundleIcon(AddCircle24Filled, AddCircle24Regular);

type FileDownloadProp = {
    buttonContent: string;
    dialogTitle: string;

};
const useStyles = makeStyles({
    content: {
        display: "flex",
        flexDirection: "column",
        rowGap: "10px",
    },
});

const FileDownload = (prop: FileDownloadProp) => {
    const styles = useStyles();
    const [files, setFiles] = useState<Job[]>([]);
    const cwClient = useContext(CWClientContext);
    const [open, setOpen] = useState(false);
    const handleSubmit = (ev: React.FormEvent) => {
        ev.preventDefault();
        alert("form submitted!");
    };

    const createMasterDownloadJob = () => {
        console.log("createMasterDownloadJob");
        cwClient.createDownloadJob().then((res) => {
            files.push(res);
            setFiles(files);
        });
        // merge files
        // setFiles
    };

    const getMasterDownloadJob = () => {
        cwClient.downloadMasterJob([JobStatus.ACCEPTED, JobStatus.PROCESSING, JobStatus.DONE]).then((res) => {
            console.log("jobs", res);
            setFiles(res);
        });
    };

    useEffect(() => { }, [files]);
    useEffect(() => {
        if (open === true) {
            getMasterDownloadJob();
        }
    }, [open]);



    return (
        <>
            <Dialog modalType="non-modal"
                open={open}
                onOpenChange={(event, data) => setOpen(data.open)}
            >
                <DialogTrigger disableButtonEnhancement>
                    <Button
                        icon={<ArrowDownload ></ArrowDownload>}
                    >{prop.buttonContent}</Button>
                </DialogTrigger>
                <DialogSurface aria-describedby={undefined}>
                    <form onSubmit={handleSubmit}>
                        <DialogBody>
                            <DialogTitle>{prop.dialogTitle}</DialogTitle>
                            <DialogContent className={styles.content}>
                                <Button
                                    icon={<AddCircle>   </AddCircle>}
                                    onClick={createMasterDownloadJob}
                                >
                                    ダウンロードファイルの作成
                                </Button>


                                <Table>
                                    <TableHeader>
                                        <TableHeaderCell>
                                            作成日
                                        </TableHeaderCell>
                                        <TableHeaderCell>
                                            作成者
                                        </TableHeaderCell>
                                        <TableHeaderCell>
                                            ダウンロード
                                        </TableHeaderCell>
                                    </TableHeader>
                                    <TableBody>
                                        {files.map((f: Job) => {
                                            let result = new JobResultParser(f);
                                            console.log("createdAt = ", typeof f.createdAt)
                                            if (typeof f.createdAt === "string") {
                                                f.createdAt = new Date(Date.parse(f.createdAt) + 9 * 60 * 60 * 1000);
                                            }
                                            return (
                                                <>
                                                    <TableRow>
                                                        <TableCell>
                                                            {f.createdAt?.getFullYear()}年
                                                            {f.createdAt?.getMonth() + 1}月
                                                            {f.createdAt?.getDate()}日
                                                            {f.createdAt?.getHours()}:
                                                            {f.createdAt?.getMinutes()}
                                                        </TableCell>
                                                        <TableCell>
                                                            {f.createBy}
                                                        </TableCell>
                                                        <TableCell>
                                                            {(f.status === JobStatus.DONE) ? (
                                                                <Button
                                                                    icon={<ArrowDownload ></ArrowDownload>}
                                                                    onClick={() => {
                                                                        let path = result.result.get("path");
                                                                        if (path !== undefined && path.length === 1) {
                                                                            cwClient.downloadFile(path[0]).then(
                                                                                (downloadLink) => {
                                                                                    window.open(downloadLink.url, "_blank");
                                                                                }
                                                                            );
                                                                        }
                                                                    }}
                                                                ></Button>
                                                            ) : ((status) => {
                                                                if (status === "ACEPTED") { return "受付済み" }
                                                                if (status === "PROCESSING") { return "処理中" }
                                                            })(f.status)}
                                                        </TableCell>
                                                    </TableRow>
                                                </>
                                            )
                                        })}
                                    </TableBody>
                                </Table>

                            </DialogContent>
                            <DialogActions>
                                <DialogTrigger disableButtonEnhancement>
                                    <Button appearance="secondary">閉じる</Button>
                                </DialogTrigger>
                            </DialogActions>
                        </DialogBody>
                    </form>
                </DialogSurface>
            </Dialog>
        </>
    );

};

export default FileDownload;